import { RootState } from '../../store';

export const getHousesSelector = (state: RootState) => state?.houseReducer?.houses;
